<template>
  <div>
    <div class="title">使用模板-导入待面试表</div>
    <div class="title_detail">
      <a :href="import_template_url" class="" style="color: #0466dd">
        <Icon type="md-cloud-download" style="margin-right: 5px" />点击下载导入模板
      </a>

      <a target="_black" :href="video_url" style="margin-left: 30px; color: #0466dd">
        <Icon style="margin-right: 5px" type="logo-youtube" />观看导入视频教程
      </a>
    </div>
    <div class="source_table">
      <TablePaste
        hide-table
        :input-props="inputProps"
        @on-success="handleSuccess"
        @on-error="handleError"
      />
    </div>
    <div class="source_table">
      <Table
        size="small"
        :height="windowHeight - 330"
        :columns="columns"
        :data="table_data"
        border
      ></Table>
    </div>
    <div class="import_button">
      <Button type="primary" @click="templaet_add" :loading="loading">
        <Icon style="margin-right: 5px" type="ios-add-circle-outline" />开始导入
      </Button>
    </div>

    <Modal width="460" v-model="tishi_show" title="温馨提示">
      <div>
        <div>模板最新更新时间：2024-03-14</div>
        导入面试模板有更新，导入记得重新下载新模板哟~🤪
        <!-- 1、因项目上反映，<span class="tishi_weight_txt">面试导入</span>的数据与招聘专员 <span
                    class="tishi_weight_txt">通过【招聘系统】邀约的数据</span>人有重复，影响系统操作。
                <br><br>
                2、现为了避免造成重复数据，所以现在通过<span class="tishi_weight_txt">【模板导入功能】</span>添加的面试数据，只导入【内推】与【代理】数据，不再对类型为
                <span class="tishi_weight_txt">【大湘内部员工】</span>
                的数据进行导入。
                <br><br>
                <span class="tishi_weight_txt">
                    3、如有归属人为【大湘内部员工】的数据：请通过【单个添加】功能进行添加。给大家带的不便敬请谅解，使用有问题请@晁凯。
                </span>
                <br><br>
                <span class="tishi_weight_txt">
                    4、【项目人员】
                </span>
                自己的邀约请通过【单个添加】的功能进行添加 -->
      </div>
    </Modal>

    <Modal width="500" v-model="success_show" title="温馨提示">
      <div class="tishi_div">
        提示：{{ res_msg }}
        <div class="tishi_div2">
          <p>未导入人员列表：</p>
          {{ res_error_name_list }}
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      inputProps: {
        rows: 6,
        placeholder: "使用说明：不用上传文件，打开表格，复制表格数据粘贴到此处",
      },
      columns: [],
      table_data: [],
      import_template_url: "",
      video_url: "",
      project_id: "",
      loading: false,
      tishi_show: true,
      res_msg: "",
      res_error_name_list: [],
      success_show: false,
    };
  },
  mounted() {
    var query = this.$route.query;
    this.project_id = query.project_id;

    this.get_import_template();
    this.window_change();
  },
  methods: {
    //模板添加
    templaet_add() {
      var that = this;
      var obj = {
        table_data: this.table_data,
        project_id: this.project_id,
      };
      this.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/template_add",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 10,
            });
            that.res_msg = res.msg;
            that.res_error_name_list = res.data.error_name_list;
            that.success_show = true;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 10,
            });
          }
          this.loading = false;
        })
        .catch((res) => {
          this.loading = false;
          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
    get_import_template() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/import_template",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.import_template_url = res.data.url;
            that.video_url = res.data.video_url;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    handleSuccess(tableData) {
      console.log(tableData);
      this.columns = tableData.columns;
      this.table_data = tableData.data;
    },
    handleError(tableData, errorIndex) {
      console.log(tableData, errorIndex);
      this.$Message.error("表格数据有误");
    },
  },
};
</script>

<style scoped>
.tishi_div2 {
  margin: 5px 0;
  border: 1px solid #ccc;
  padding: 10px;

  height: 140px;
  overflow: auto;
}

.tishi_div {
  padding: 10px;
  height: 200px;
}

.tishi_weight_txt {
  font-weight: 600;
  color: rgb(218, 0, 0);
}

.import_button {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}

.title_detail {
  padding: 10px 15px;
}

.source_table {
  padding: 10px;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: #0466dd;
  text-align: center;
  padding: 10px;
}
</style>
